import { render } from "./icon-reviewed.svg?vue&type=template&id=c1acf12b&scoped=true&component"
const script = {}

import "./icon-reviewed.svg?vue&type=style&index=0&id=c1acf12b&scoped=true&lang=css&component"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1acf12b"]])

export default __exports__